/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Flex } from '@chakra-ui/react';
import { BudgetBarChart } from 'Deer/components/Compensation/BudgetBarChart';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const PlanningGraph = ({ activeTabId }: { activeTabId: string }) => {
  let budgetBarProps = {
    totalBudget: 100000,
    currentComp: 60000,
    proposedComp: 20000,
    targetBudget: 100000,
  };

  if (activeTabId === 'publish') {
    budgetBarProps = {
      totalBudget: 1000000,
      currentComp: 600000,
      proposedComp: 300000,
      targetBudget: 1000000,
    };
  }

  return (
    <Flex flexDir="column" h="100%" p="12px" gap="40px">
      <Flex flexDir="column">
        <TextBodyMedium bold>Compensation summary</TextBodyMedium>
        <TextLabel>How well your current compensation change fits within your budget.</TextLabel>
      </Flex>
      <Box flex={1}>
        <BudgetBarChart {...budgetBarProps} />
      </Box>
    </Flex>
  );
};

export default PlanningGraph;
